/**
 * @fileoverview `useAccountAppsUiTranslate(t)` — the account-apps-ui corpus's translator.
 * @package @puffin-core/account-apps-ui
 *
 * Resolution order: the consumer's `t` (honoured first) → the `accountAppsUi` namespace on the instance
 * in the React tree → `ACCOUNT_APPS_UI_EN`, so an unwired tree renders readable English.
 *
 * `braces: 'single'` + `onMissing: 'keep'`: a placeholder whose param did not arrive is echoed back
 * (`{price}`), so a missing param stays VISIBLE rather than blanking the sentence.
 *
 * ⚠️ Hook-placement rule (RECIPE §3): call this immediately above the first hook or expression that
 * consumes the translator — a custom hook above computed hooks makes `web/component-state-order`
 * report every one of them.
 *
 * @module @puffin-core/account-apps-ui/hooks/useAccountAppsUiTranslate
 */

import { createInterpolator } from '@puffin-core/i18n-bootstrap/strings-kit';
import { createNamespaceTranslate } from '@puffin-core/i18n-bootstrap/namespace-translate';

import { ACCOUNT_APPS_UI_NAMESPACE } from '../strings/namespace.js';
import { resolveString } from '../strings/resolveString.js';

export const useAccountAppsUiTranslate = createNamespaceTranslate({
  namespace: ACCOUNT_APPS_UI_NAMESPACE,
  resolveString,
  interpolate: createInterpolator({ braces: 'single', onMissing: 'keep' }),
});
